import ExpansionQuestNPCDTO from "../../models/quest/ExpansionQuestNPCDTO";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function getNPCs(client: BackendClient): Promise<Array<ExpansionQuestNPCDTO>> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<Array<ExpansionQuestNPCDTO>>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.GetNPCs}`, {headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when getting quest npcs: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }